import { render } from "./CreateAutoAnnotationTaskModal.vue?vue&type=template&id=6c5d2996&scoped=true"
import script from "./CreateAutoAnnotationTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateAutoAnnotationTaskModal.vue?vue&type=script&lang=js"

import "./CreateAutoAnnotationTaskModal.vue?vue&type=style&index=0&id=6c5d2996&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5d2996"]])

export default __exports__